export const PRODUCT_IDS = {
  INVITATIONS: 832416,
  UNLIMITED_GUESTS: 832443,
};

export const GUEST_LIMIT_WITHOUT_UPGRADE = 99;

export const toNumericProductId = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const normalizeActiveProductIds = (payload) => {
  const activeFromIds = Array.isArray(payload?.active_product_ids)
    ? payload.active_product_ids
    : [];
  const activeFromEntitlements = Array.isArray(payload?.entitlements)
    ? payload.entitlements
        .filter((item) => Boolean(item?.is_active))
        .map((item) => item?.product_id)
    : [];

  return Array.from(
    new Set(
      [...activeFromIds, ...activeFromEntitlements]
        .map((id) => toNumericProductId(id))
        .filter((id) => id !== null)
    )
  );
};
